"use client";

import * as SliderPrimitive from "@radix-ui/react-slider";
import { joinClassNames } from "@utils/helpers";
import * as React from "react";

/**
 * A global slider UI, that can be used for example as a dynamic price slider
 */
const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={joinClassNames(
      "relative flex w-full touch-none select-none items-center",
      className ?? ""
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-[#FFD3E2]">
      <SliderPrimitive.Range className="absolute h-full bg-iticket" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-iticket/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export default Slider;
